export default __webpack_public_path__ + "static/media/aus.5dab49c8.svg";